export const LANGUAGES: Array<{ lang: AvailableLanguages; label: string }> = [
  { lang: 'es', label: 'HEADER.LANG.ES' },
  { lang: 'en', label: 'HEADER.LANG.EN' },
  { lang: 'pt', label: 'HEADER.LANG.PT' },
];

export type AvailableLanguages = 'es' | 'en' | 'pt';
